export default "__VITE_ASSET__Co0wOG2I__"